import { Col, Row } from 'reactstrap';
import SingleGroupByButton from 'shared/components/SingleGroupByButton.jsx';
import { CostUsageStates, K8S_GROUP_BY_LOV } from 'usage/constants/costAndUsageConstants.js';
import {
  COST_BREAKDOWN_TABLE_COLUMNS_EXTENSIONS,
  COST_BREAKDOWN_TABLE_COLUMNS_WIDTHS,
  COST_BREAKDOWN_TABLE_COST_COLUMNS,
  getCostBreakdownTableColumns,
  mapCostBreakDownGroupByDisplayToValue,
  mapCostBreakDownGroupByValueToDisplay,
} from 'kubernetes/constants/k8sConstants.js';
import DatePickerFilter from 'shared/components/DatePickerFilter.jsx';
import DevExpSearchAndVisibilityTable from 'shared/components/tables/DevExpSearchAndVisibilityTable.jsx';
import React, { useMemo, useState } from 'react';
import {
  buildStartAndEndDate,
  buildTimeDiffDateFromBaseDate,
  createTimeZoneAgnosticDateFromStr,
} from 'shared/utils/dateUtil.js';
import { useKubernetes } from 'kubernetes/hooks/useKubernetes.js';
import Spinner from 'shared/components/andtComponents/Spinner';
import { useUserSettingsContext } from 'users/utils/contexts/UserSettingsContext';

const defaultDates = () => {
  let { startDate, endDate } = buildStartAndEndDate(null, null);
  const fourteenDaysDate = buildTimeDiffDateFromBaseDate(endDate, -14, 'd').startDate;
  startDate = new Date(fourteenDaysDate) > new Date(startDate) ? startDate : fourteenDaysDate;
  const agnosticStartDate = createTimeZoneAgnosticDateFromStr(startDate);
  const agnosticEndDate = createTimeZoneAgnosticDateFromStr(endDate);
  return { startDate, endDate, agnosticStartDate, agnosticEndDate };
};

const K8SCostBreakdown = () => {
  const { getCurrencyNumber } = useUserSettingsContext();
  const columns = useMemo(() => getCostBreakdownTableColumns(getCurrencyNumber), [getCurrencyNumber]);

  const [costBreakdownTableGroupBy, setCostBreakdownTableGroupBy] = useState(CostUsageStates.CLUSTER);
  const [startDate, setStartDate] = useState(defaultDates().agnosticStartDate);
  const [endDate, setEndDate] = useState(defaultDates().agnosticEndDate);
  const { fetchCostBreakDownData } = useKubernetes(startDate, endDate, costBreakdownTableGroupBy);

  let { data: costBreakDownData, isLoading: isCostBreakLoading } = fetchCostBreakDownData();

  const csvData = useMemo(() => {
    if (!costBreakDownData) {
      return [];
    }
    return costBreakDownData;
  }, [costBreakDownData]);

  const handleDateChange = ({ startDate: newStartDate, endDate: newEndDate }) => {
    const start = buildStartAndEndDate(newStartDate, newEndDate).startDate;
    const end = buildStartAndEndDate(newStartDate, newEndDate).endDate;
    setStartDate(start);
    setEndDate(end);
  };

  if (isCostBreakLoading) {
    return (
      <div style={{ height: 400 }}>
        <Spinner />
      </div>
    );
  }

  return (
    <>
      <Row style={{ marginBottom: '25px' }}>
        <Col xs="12" md="12" lg="12" xl="12">
          <SingleGroupByButton
            title="Group By: "
            items={[K8S_GROUP_BY_LOV.BY_CLUSTER, K8S_GROUP_BY_LOV.BY_NAMESPACE, K8S_GROUP_BY_LOV.BY_NODE_GROUP]}
            handler={setCostBreakdownTableGroupBy}
            selectedItem={mapCostBreakDownGroupByValueToDisplay.get(costBreakdownTableGroupBy)}
            itemsValuesMap={mapCostBreakDownGroupByDisplayToValue}
            isIconButton
          />
        </Col>
        <Col xs="12" md="12" lg="12" xl="12">
          <DatePickerFilter
            onDateChange={handleDateChange}
            startDate={startDate}
            endDate={endDate}
            currPeriodGranLevel="day"
          />
        </Col>
      </Row>
      {csvData.length > 0 && (
        <Row>
          <Col xs="12" md="12" lg="12" xl="12">
            <DevExpSearchAndVisibilityTable
              data={costBreakDownData}
              csvData={csvData}
              columns={columns}
              costColumnsArray={COST_BREAKDOWN_TABLE_COST_COLUMNS}
              currenciesColumns={COST_BREAKDOWN_TABLE_COST_COLUMNS}
              tableColumnExtensions={COST_BREAKDOWN_TABLE_COLUMNS_EXTENSIONS}
              csvTitle="k8s-waste"
              columnWidths={COST_BREAKDOWN_TABLE_COLUMNS_WIDTHS}
              defaultHiddenColumnNames={[]}
              defaultSorting={[]}
              isResize
              isPaging
              isVisibility={false}
              key={`${startDate}${endDate}${costBreakdownTableGroupBy}`}
            />
          </Col>
        </Row>
      )}
    </>
  );
};

export default K8SCostBreakdown;
